module.exports = __webpack_public_path__ + "img/m2g_readmore.0122342e.png";